import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const DocumentSvg = () => (
  <svg width="24" height="24" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.414 0H2C0.897 0 0 0.898 0 2V18C0 19.103 0.897 20 2 20H14C15.103 20 16 19.103 16 18V4.586L11.414 0ZM14.001 18H2V2H10V6H14L14.001 18Z" fill="currentColor" />
    <path d="M4 9H10V11H4V9Z" fill="currentColor" />
    <path d="M4 13H12V15H4V13Z" fill="currentColor" />
  </svg>
);

const Document = (props: IIconProps) => <Icon component={DocumentSvg} {...props} />;

export default Document;
